require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./es-locations-masaya-aeromundo.json") })
        }
      }, "path---es-locations-masaya-aeromundo");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---es-locations-masaya-aeromundo!./.cache/json/es-locations-masaya-aeromundo.json
// module id = 1107
// module chunks = 231608221292675